import React from 'react';

/** What an issue or email draft must tell Randall before he acts on it (11 Sep 2026): skipped,
 *  held, deleted in MailerLite, a planned send time, and any open review item — one of which is
 *  the "12 Aug test is void" note on the moved T2T. Opaque colours: the Hub is a light theme. */
export const NOTICE_STYLE = {
  skipped: { bg: '#EFEFEF', fg: '#3D3D3D' },
  held: { bg: '#FFF1DB', fg: '#7A4100' },
  deleted: { bg: '#FDE8E8', fg: '#8B1A1A' },
  review: { bg: '#E8F4FD', fg: '#0B4A75' },
};

export function statusLabel(d) {
  if (!d) return 'Draft';
  if (d.status === 'skipped' || d.skipped) return 'Skipped';
  if (d.status === 'campaign_deleted') return 'Campaign deleted';
  if (d.held_reason) return 'Held';
  if (d.status === 'scheduled') return 'Scheduled';
  if (d.status === 'sent') return 'Sent';
  if (d.status === 'pushed') return 'Pushed';
  return d.test_sent_at ? 'Test-sent' : 'Draft';
}

function Line({ kind, children, testid }) {
  const s = NOTICE_STYLE[kind];
  return (
    <li data-testid={testid} className="text-[11px] font-sans px-2 py-1 rounded-sm"
        style={{ background: s.bg, color: s.fg }}>{children}</li>
  );
}

export default function IssueNotices({ issue }) {
  if (!issue) return null;
  const open = (issue.review_items || []).filter((r) => r.state !== 'resolved');
  const planned = issue.planned_send_at;
  const any = issue.skipped || issue.held_reason || issue.campaign_deleted || planned || open.length;
  if (!any) return null;
  const fmt = (s) => { try { return new Date(s).toLocaleString(); } catch { return s; } };
  return (
    <ul data-testid="issue-notices" className="space-y-1">
      {issue.skipped && (
        <Line kind="skipped" testid="notice-skipped">Skipped — {issue.skipped.reason}</Line>
      )}
      {issue.held_reason && (
        <Line kind="held" testid="notice-held">Held until {issue.held_until || 'the hold lifts'} — {issue.held_reason}</Line>
      )}
      {issue.campaign_deleted && (
        <Line kind="deleted" testid="notice-deleted">{issue.campaign_deleted.note}</Line>
      )}
      {planned && (
        <Line kind="review" testid="notice-planned">Planned send: {fmt(planned)} — schedule it once approved</Line>
      )}
      {open.map((r, i) => (
        <Line key={i} kind="review" testid={`notice-review-${i}`}>For review: {r.section}</Line>
      ))}
    </ul>
  );
}
